import { DataObject } from '@mui/icons-material';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { FetchBranchShowData, LocationShowdata, SpecializationAdd, SpecializationUpdate } from '../../../services/LoginPageService';

const SpecializationModel = ({open, setOpen, isAddButton, editSpecialization,setRefreshData,setNotification}) => {
    const [location,setLocation]=useState('');
    const [locationList,setLocationList]=useState([]);
    const [LocDisabled,setLocDisabled] = useState(false);
    const[branch,setBranch]=useState('');
    const[branchList,setBranchList]=useState([]);
    const[specialization,setSpecialization]=useState('');
    const[description,setDescription]=useState('');

    const handleClose = () => {
        setOpen(false);
        clearForm();
    };

    useEffect(()=>{
        LocationShowdata(handleLocationshow,handleLocationshowException);
        setBranch(editSpecialization?.branchId || '');
        setSpecialization(editSpecialization?.specialization || '');
        setDescription(editSpecialization?.description || '');
        setLocation(editSpecialization?.locationId || '');
        if(editSpecialization)
        {
            SelectionDisabled();
        }
    },[editSpecialization])

    const SelectionDisabled = ()=>{
        setLocDisabled(true);
    }

    const handleLocationshow=(dataObject)=>{
        setLocationList(dataObject?.data);
        console.log(dataObject?.data);
        if(editSpecialization?.locationId)
        {
            FetchBranchShowData({id:editSpecialization?.locationId},handleBranchSuccess, handleBranchException);
        }
    }

    const handleLocationshowException=(error,errorMessage)=>{
        console.log(errorMessage);
    }

    const handleBranchSuccess = (dataObject) =>{
        console.log('data Branch');
        setBranchList(dataObject.data);
    }
      
    const handleBranchException= (errorStaus, errorMessage) =>{
        console.log(errorMessage);
    }

    const onLocationChange=(e)=>{
        setLocation(e.target.value);
        FetchBranchShowData({id:e.target.value},handleBranchSuccess, handleBranchException);
    }

    const onBranchChange=(e)=>{
        setBranch(e.target.value);
    }

    // const isValidInput = (inputValue) => {
    //     // Regular expression to validate the input: only allow letters and spaces
    //     const regex = /^[A-Za-z\s]+$/;
    //     return regex.test(inputValue);
    // };
const isValidInput = (inputValue) => {
    return true;
};



    const handleSpecializationChange = (e) => {
    const inputValue = e.target.value;
    if (isValidInput(inputValue)) {
        setSpecialization(inputValue);
    } else {
        // Check if the input value is empty after backspace, then clear the location
        if (inputValue === '') {
            setSpecialization('');
        }
    }
    };
    const onSubmit = (e) => {
        e.preventDefault();
        isAddButton === true ?
        (
            SpecializationAdd({
                id:location,
                location:location,
                branch:branch,
                specialization:specialization,
                description:description,
            }, handleAddSuccess, handleException)
        ) : (
            SpecializationUpdate({
                id: editSpecialization.id,
                location:location,
                branch:branch,
                specialization:specialization,
                description:description,
          }, handleUpdateSuccess, handleException)
        );
    }

    const handleAddSuccess = (dataObject) => {
        console.log(dataObject); 
        setNotification({
          status: true,
          type: 'success',
          message: dataObject.message,
        });
        setTimeout(() => {
            setOpen(false);
        }, 2000);
        setRefreshData(oldValue => !oldValue);
        clearForm();
    }

    const clearForm = () => {
        setLocation('');
        setDescription('');
        setBranch('');
        setBranchList([]);
        setSpecialization('');
        setLocDisabled(false);
        setRefreshData(oldValue => !oldValue);
    }  
    
    const handleUpdateSuccess = (dataObject) => {
        console.log(dataObject);
        setNotification({
          status: true,
          type: 'success',
          message: dataObject.message,
        });
        setTimeout(() => {
            setOpen(false);
        }, 2000);
        setRefreshData(oldValue => !oldValue);
        clearForm();
    }

    const handleException = (errorObject, errorMessage) => {
        console.log(errorMessage);
        setNotification({
          status: true,
          type: 'error',
          message: errorMessage,
        });
        setLocation('');
        setDescription('');
        setBranch('');
        setSpecialization('');
        clearForm();
    }

    return (
        <div>
            <Dialog
            sx={{ '& .MuiDialog-paper': { width: '32%', maxHeight: '100%' } }}
            maxWidth="lg"
            open={open}>
                <form onSubmit={onSubmit}>
                    <DialogTitle style={{background:'#f7f7f7',color:'black'}}>
                        {isAddButton === true ? 'Add ' : 'Update '}Specialization
                    </DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2} style={{marginTop:'20px'}}>  
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Location</InputLabel>
                                    <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Location"
                                    placeholder='Location'
                                    value={location}
                                    disabled ={LocDisabled}
                                    required
                                    onChange={(e) => onLocationChange(e) }>
                                    {
                                        locationList?.map((data, index) => {
                                            return (
                                                <MenuItem value={data.id} key={index}>{data.location}</MenuItem>
                                            )
                                        })
                                    }      
                                    
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Hostel Name</InputLabel>
                                    <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Hostel Name"
                                    placeholder='Hostel Name'
                                    value={branch}
                                    required
                                    onChange={(e) => onBranchChange(e) }>
                                        {
                                            branchList.length !== 0 ? (

                                            <MenuItem value="" key={0}>
                                            <em>Select Hostel Name</em>
                                            </MenuItem>
                                            )
                                        :
                                         (   <MenuItem value="" key={0}>
                                            <em>Select Location </em>
                                            </MenuItem>
                                        )}
                                    {
                                        branchList?.map((data, index) => {
                                            return (
                                                <MenuItem value={data.id} key={index}>{data.branch}</MenuItem>
                                            )
                                        })

                                    }      
                                    
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <TextField 
                        fullWidth 
                        label="Specialization"
                        placeholder='Specialization'
                        variant="outlined"
                        required
                        onChange={handleSpecializationChange}
                        // onChange={(e) => { setSpecialization(e.target.value) }}
                        value={specialization}
                    />
                        </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <TextField
                            fullWidth 
                            label="Description"
                            placeholder='Description'
                            variant="outlined"
                            required
                            onChange={(e) => { setDescription(e.target.value) }}
                            value={description}
                        />
                        </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                <Button type='submit'>
                {
                    isAddButton ? 'Add' : 'update'
                }       
                </Button>
                <Button onClick={handleClose}>Cancel</Button>
                </DialogActions>
                </form>
            </Dialog>
        
        </div>
    )
}

export default SpecializationModel
